// extracted by mini-css-extract-plugin
export var bottomRightDock = "_15-0";